import { put, getContext } from 'redux-saga/effects'
import importer from 'common/importer'
const { getLanguages } = importer('GraphQL/Queries')
const PublicContentActions = importer('Stores/PublicContent/Actions')
export default function * main () {
  try {
    yield put(PublicContentActions.getLanguagesLoading())
    const apolloClient = yield getContext('client')
    const query = getLanguages
    const {data, error} = yield apolloClient.query({query})
    if (error) { throw error }
    const list = data.pdt_language.map((c) => ({ label: c.description, value: c.code, key: c.code }))
    yield put(PublicContentActions.getLanguagesSuccess(list))
  } catch (error) {
    yield put(PublicContentActions.getLanguagesFailure(error))
  }
}
